module.exports = __webpack_public_path__ + "img/image52.dae3ddc1.jpg";